import {ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
    AdvanceSaleConfigurationComponent
} from "../../../pages/action-points/action-points-configuration/advance-sale-configuration/advance-sale-configuration.component";
import {
    AdvanceSaleGroup,
    AdvanceSaleGroupProduct, AdvanceSaleRequiredProductGroup
} from "../../../../model/club-gigot/action-points/action-points-configuration.model";
import {MatTableDataSource} from "@angular/material/table";
import {ActionPointsService} from "../../../../service/club-gigot/action-points.service";
import {
    ActionPointsAdvanceSaleResult, ActionPointsRequiredGroupResult
} from "../../../../model/club-gigot/action-points/action-points-advance-sale-result.model";

@Component({
  selector: 'kt-dialog-advanced-sale-required-product-group',
  templateUrl: './dialog-advanced-sale-required-product-group.component.html',
  styleUrls: ['./dialog-advanced-sale-required-product-group.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogAdvancedSaleRequiredProductGroupComponent implements OnInit {

    public advancedSaleRequiredProductGroupForm: FormGroup;
    tableDataSource = new MatTableDataSource<AdvanceSaleGroupProduct| any>();

    _isEditMode: boolean = false;
    filteredProducts: AdvanceSaleGroupProduct[] = [];

    public displayedColumnsProduct = ['product', 'required', 'actions'];


    constructor(@Inject (MAT_DIALOG_DATA)
                public data: DialogData,
                private dialogRef: MatDialogRef<DialogAdvancedSaleRequiredProductGroupComponent>,
                private actionPointsService: ActionPointsService,
                private cdr: ChangeDetectorRef) { }

  ngOnInit() {
        //Filter products with same codes
      this._isEditMode = this.data.advanceSaleRequiredGroup !== undefined;
      console.log(this._isEditMode);
      if (this._isEditMode) {
          this.filteredProducts = this.data.advanceSale.advanceSaleProducts.filter((product, index, self) =>
              (product.advanceSaleRequiredProductGroupId == null || product.advanceSaleRequiredProductGroupId === this.data.advanceSaleRequiredGroup.id) && index === self.findIndex((t) => (
                      t.product.code === product.product.code
                  ))
          );
      } else {
          this.filteredProducts = this.data.advanceSale.advanceSaleProducts.filter((product, index, self) =>
                  product.advanceSaleRequiredProductGroupId == null && index === self.findIndex((t) => (
                      t.product.code === product.product.code
                  ))
          );
      }

      this.tableDataSource = new MatTableDataSource(this.filteredProducts);
      this.buildForms();
  }

    private setProductForm(): FormGroup[] {
        let form: FormGroup[] = [];
        if(!this._isEditMode){
            for(let product of this.filteredProducts){
                let formGroup = new FormGroup(
                    {
                        product: new FormControl(product.product),
                        required: new FormControl(false),
                    }
                )
                form.push(formGroup);
            }
        } else {
            for(let product of this.filteredProducts){
                let groupProd = this.data.advanceSaleRequiredGroup.advanceSaleRequiredProducts.find(x => x.product.code == product.product.code);
                if (groupProd != undefined) {
                    let formGroup = new FormGroup(
                        {
                            product: new FormControl(product.product),
                            required: new FormControl(groupProd.advanceSaleRequiredProductGroupId != null),
                        })

                    form.push(formGroup);
                } else {
                    let formGroup = new FormGroup(
                        {
                            product: new FormControl(product.product),
                            required: new FormControl(false),
                        });
                    form.push(formGroup);
                }

            }
        }

        return form;
    }

    public setRequired(formGroup: FormGroup){
        if(formGroup.controls['required'].value){
        }else{
            formGroup.updateValueAndValidity()
        }
        this.advancedSaleRequiredProductGroupForm.updateValueAndValidity()
        this.cdr.detectChanges();
    }

    public buildForms(){
        if(!this._isEditMode) {
            this.advancedSaleRequiredProductGroupForm = new FormGroup({
                products: new FormArray(this.setProductForm()),
                minimum: new FormControl(null, [Validators.required, Validators.min(1)]),
                name: new FormControl(null, [Validators.required])
            });
        } else {
            this.advancedSaleRequiredProductGroupForm = new FormGroup({
                products: new FormArray(this.setProductForm()),
                minimum: new FormControl(this.data.advanceSaleRequiredGroup.quantity, [Validators.required, Validators.min(1)]),
                name: new FormControl(this.data.advanceSaleRequiredGroup.name, [Validators.required])
            });
        }

/*        this.advancedSaleGroupForm = new FormGroup({
            id : new FormControl((this._isEditMode && this.data.actionPointData != undefined) ? this.data.actionPointData.id : null),
            minimum: new FormControl(this._isEditMode ? this.data.actionPointData.minimumCampaignProducts: null, [Validators.required, Validators.min(1)]),
            maximum: new FormControl(this._isEditMode ? this.data.actionPointData.maximumCampaignProducts: null, [Validators.required]),
            minimumValue: new FormControl(this._isEditMode ? this.data.actionPointData.minimumValue: null, [Validators.required]),
            maximumValue: new FormControl(this._isEditMode ? this.data.actionPointData.maximumValue: null, [Validators.required]),
            points: new FormControl(this._isEditMode ? this.data.actionPointData.points: null, [Validators.required, Validators.min(1)]),
            name : new FormControl(this._isEditMode ? this.data.actionPointData.name : null, [Validators.required]),
            campaignsToNet: new FormControl(this._isEditMode ? this.data.actionPointData.campaignsToNet.toString() : null, [Validators.required]),
            expirationPointsCampaignSequence: new FormControl(this._isEditMode ? (this.data.actionPointData.expirationPointsCampaignSequence - this.data.campaignSequence).toString() : null, [Validators.required]),
            reachId: new FormControl(this._isEditMode ? this.data.actionPointData.reachId : null)
        })*/
/*
        this.advancedSaleRequiredProductGroupForm.controls['minimum'].setValidators([Validators.required, Validators.min(1), this.validateGroupMinimum()])
*/
        this.tableDataSource = new MatTableDataSource(this.getFormArray().controls);
    }

    public getFormArray(): FormArray{
        return this.advancedSaleRequiredProductGroupForm.controls['products'] as FormArray;
    }

    public onNoClick(): void {
        this.dialogRef.close();
    }

    public saveGroup() {
        //get all campaign Products with the selected product codes
        let selectedProducts = this.advancedSaleRequiredProductGroupForm.controls['products'].value.filter(p => p.required);
        let selectedCampaignProducts = this.data.advanceSale.advanceSaleProducts.filter(p => selectedProducts.filter(sp => sp.product.code == p.product.code).length > 0);
        let group = new AdvanceSaleRequiredProductGroup(this.data.advanceSale.id, this.advancedSaleRequiredProductGroupForm.controls['minimum'].value, this.advancedSaleRequiredProductGroupForm.controls['name'].value, selectedCampaignProducts);
        if(this._isEditMode) {
            group.id = this.data.advanceSaleRequiredGroup.id;
            this.dialogRef.close(new ActionPointsRequiredGroupResult(true, true, group));
        } else {
            this.actionPointsService.saveRequiredProductGroup(group).subscribe({
                next: value => {
                    this.dialogRef.close(new ActionPointsAdvanceSaleResult(false, true));
                }
            });
        }

    }
}

export interface DialogData {
    advanceSale: AdvanceSaleGroup;
    products: AdvanceSaleGroupProduct[];
    advanceSaleRequiredGroup: AdvanceSaleRequiredProductGroup;
}
